module.exports = __webpack_public_path__ + "static/media/email.86799684.svg";